import React from "react";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

import { AUTH } from "helpers/routes";
import styles from "./styles.module.scss";
import { saveLoginReferrer } from "@/utils/loginReferrer";

const AuthMessage = ({ open, onClose }) =>
    open && (
        <>
            <div className={styles.authMessage}>
                <div className={styles.container}>
                    <Trans
                        i18nKey="login.loginOrRegister"
                        components={{
                            enter: (
                                <Link
                                  to={AUTH.login}
                                  className={styles.link}
                                  onClick={() => {
                                    saveLoginReferrer();
                                    onClose();
                                  }}
                                />
                            ),
                            reg: (
                                <Link
                                    to={AUTH.registration}
                                    className={styles.link}
                                    onClick={() => {
                                      saveLoginReferrer();
                                      onClose();
                                    }}
                                />
                            ),
                        }}
                    />
                    <button className={styles.button} type="button" onClick={onClose} />
                </div>
            </div>
        </>
    );

export default AuthMessage;
